import styled from 'styled-components';
import { LeftSection, EnkiLogo, Nav, NavbarWrapper } from '.';

const CenteredSection = styled(LeftSection)`
  width: 100%;
  justify-content: center;
`;

export default function Navbar({ className }: { className?: string }) {
  return (
    <NavbarWrapper className={className}>
      <div className="inner">
        <Nav>
          <CenteredSection>
            <EnkiLogo />
          </CenteredSection>
        </Nav>
      </div>
    </NavbarWrapper>
  );
}
